import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getBusinessLoanById, getAllAdmins } from "../../../middleware/backend_hepler";
import { AuthContext } from "../../../Context/AuthContext";
import { FaEdit } from 'react-icons/fa';
import { Row, Col, Button } from "react-bootstrap";
import PdfDownloader from "../../../common/PdfDownloader";


const EditBusinessViewModal = ({ isOpen, onClose, loanId }) => {
  const { adminId, adminName, adminRole } = useContext(AuthContext);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    form_id: "",
    created_id: "",
    created_by: "",
    assigned_to: "",
    status: "",
    rejected_reason: "",
    name: "",
    age: "",
    dob: "",
    mobile: "",
    email: "",
    location: "",
    state: "",
    pincode: "",
    city: "",
    present_address_adhaar: "",
    current_location: "",
    current_state: "",
    current_city: "",
    current_pincode: "",
    current_landmark: "",
    add_co_applicant: "",
    co_applicant_name: "",
    co_applicant_dob: "",
    co_applicant_relationship: "",
    co_applicant_spouse_name: "",
    co_applicant_fathers_name: "",
    co_applicant_mothers_name: "",
    co_applicant_son_name: "",
    co_applicant_daughter_name: "",
    required_loan_amount: "",
    turnover: "",
    gst_registered: "",
    existing_emi_amount: "",
    company_type: "",
    gst_registerd_year: "",
    msme_registered: "",
    filling_itr: "",
    add_reference: "",
    reference_name: "",
    reference_mobile: "",
    reference_address: "",
    reference_location: "",
    bank_name: "",
  });

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const response = await getAllAdmins();
        const filteredAgents = response.filter((admin) => admin.role === "employee");
        setAgents(filteredAgents);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching agents:", error);
      }
    };

    fetchAgents();
  }, []);

  useEffect(() => {
    const fetchLoanData = async () => {
      if (loanId && isOpen) {
        try {
          const loan = await getBusinessLoanById(loanId);
          setFormData((prevFormData) => ({
            ...prevFormData,
            ...loan,
            dob: loan.dob?.toString() || "",
            required_loan_amount: loan.required_loan_amount?.toString() || "",
            existing_emi: loan.existing_emi?.toString() || "",
            project_gross_value: loan.project_gross_value?.toString() || "",
            // required_loan_amount: loan.required_loan_amount || "",
          }));
        } catch (error) {
          console.error("Error fetching business loan data:", error);
        }
      }
    };

    fetchLoanData();
  }, [loanId, adminId, adminName]);

  const filteredPdfFormData = [
    {
      title: "Personal Details",
      data: {
        "Loan ID": formData.form_id,
        "Agent ID": formData.created_id,
        "Agent": formData.created_by,
        "Assign to": formData.assigned_to,
        "Lead Status": formData.status,
        ...(formData.status === "Rejected" && {
          "Rejected Reason": formData.rejected_reason
        }),
        "Name": formData.name,
        "Date of Birth": formData.dob,
        "Age": formData.age,
        "Father Name": formData.father_name,
        "Mother Name": formData.mother_name,
        "Mobile": formData.mobile,
        "Email": formData.email,
        "Marital Status": formData.marital_status,
        ...(formData.marital_status === "married" && {
          "Spouse Name": formData.spouse_name
        }),
        "Residence Type": formData.residence_type,
        "Present Staying Address": formData.location,
        "Landmark": formData.landmark,
        "State": formData.state,
        "City": formData.city,
        "Pincode": formData.pincode,
        "Is your Present Address as per Aadhaar": formData.present_address_adhaar,
        ...(formData.present_address_adhaar === "No" && {
          "Present Aadhaar Address": formData.current_location,
          "State(Aadhaar)": formData.current_state,
          "City(Aadhaar)": formData.current_city,
          "Pincode(Aadhaar)": formData.current_pincode,
          "Landmark(Aadhaar)": formData.current_landmark,
        }),
        "Add Co-Applicant": formData.add_co_applicant,
      }
    },
    {
      title: "Co-Applicant Details",
      data: formData.add_co_applicant === "Yes" ? {
        "Relationship with Applicant": formData.co_applicant_relationship,
        ...(formData.co_applicant_relationship === "spouse" && {
          "Co-Applicant Spouse Name": formData.co_applicant_spouse_name
        }),
        ...(formData.co_applicant_relationship === "father" && {
          "Co-Applicant Father Name": formData.co_applicant_fathers_name
        }),
        ...(formData.co_applicant_relationship === "mother" && {
          "Co-Applicant Mother Name": formData.co_applicant_mothers_name
        }),
        ...(formData.co_applicant_relationship === "son" && {
          "Co-Applicant Son Name": formData.co_applicant_son_name
        }),
        ...(formData.co_applicant_relationship === "daughter" && {
          "Co-Applicant Daughter Name": formData.co_applicant_daughter_name
        }),
        "Co-Applicant Mobile": formData.co_applicant_mobile,
        "Co-Applicant Email": formData.co_applicant_email,
      } : {}
    },
    {
      title: "Income Details",
      data: {
        "Required Loan Amount": formData.required_loan_amount,
        "Annual Turnover": formData.turnover,
        "Existing EMI Amount": formData.existing_emi_amount,
        "Bank Name": formData.bank_name,
        "Company Registered As": formData.company_type,
        "Nature of Business": formData.business_type,
        ...(formData.business_type === "others" && {
          "Others": formData.description
        }),
        "Business Place": formData.business_property,
        ...(formData.business_property === "Own" && {
          "Business Start Year": formData.business_year
        }),
        "GST Registered": formData.gst_registered,
        ...(formData.gst_registered === "Yes" && {
          "GST Registered Year": formData.gst_registerd_year
        }),
        "MSME Registered": formData.msme_registered,
        "Are You Filing ITR": formData.filling_itr
      }
    },
    {
      title: "Reference Details",
      data: (formData.add_reference === "Relative" || formData.add_reference === "Colleague") ? {
        "Add Reference": formData.add_reference,
        "Name": formData.reference_name,
        "Mobile": formData.reference_mobile,
        "Address": formData.reference_address,
        "Location": formData.reference_location
      } : {}
    }
  ];

  const handleEditClick = () => {
    navigate(`/edit-business-loan/${loanId}`);
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('modal-overlay-edit')) {
      onClose();
    }
  };

  const formattedDob = formData.dob
    ? (() => {
        const d = new Date(formData.dob);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      })()
    : "";

  if (!isOpen) return null;

  return (
    <div className="modal-overlay-edit" onClick={handleOverlayClick}>
      <div className="modal-content-edit">
      <h3 className="edit-title">
        <span className="product-title-text">Business Loan</span>
        <span className="action-icon">
          <FaEdit
            className="edit-loan"
            style={{ cursor: "pointer" }}
            onClick={handleEditClick}
          />
          <PdfDownloader formData={filteredPdfFormData} loanId={loanId} />
        </span>
      </h3>
        <div className="form-content-section">
          <div className="step-sections-personal-details-sections">
            <h4>Personal Details</h4>
            <div className="form-row-step">
              <strong>Loan ID:</strong>
              <div className="value">{formData.form_id}</div>
            </div>
            {adminRole !== "customer"&&(
              <>
                <div className="form-row-step">
                  <strong>Employee ID:</strong>
                  <div className="value">{formData.created_id}</div>
                </div>

                <div className="form-row-step">
                  <strong>Employee:</strong>
                  <div className="value">{formData.created_by}</div>
                </div>
              </>
            )}
            {(adminRole === "admin")&&(
              <div className="form-row-step">
                <strong>Assign to:</strong>
                <div className="value">{formData.assigned_to}</div>
              </div>
            )}
            <div className="form-row-step">
              <strong>Lead Status:</strong>
              <div className="value">{formData.status}</div>
            </div>

            {formData.status === "Rejected" && (
              <div className="form-row-step">
                <strong>Rejected reason:</strong>
                <div className="value">{formData.rejected_reason}</div>
              </div>
            )}

            <div className="form-row-step">
              <strong>Name:</strong>
              <div className="value">{formData.name}</div>
            </div>

            <div className="form-row-step">
              <strong>Date Of Birth:</strong>
              <div className="value">{formattedDob}</div>
            </div>

            <div className="form-row-step">
              <strong>Age:</strong>
              <div className="value">{formData.age}</div>
            </div>

            <div className="form-row-step">
              <strong>Father Name:</strong>
              <div className="value">{formData.father_name}</div>
            </div>

            <div className="form-row-step">
              <strong>Mother Name:</strong>
              <div className="value">{formData.mother_name}</div>
            </div>

            <div className="form-row-step">
              <strong>Mobile:</strong>
              <div className="value">{formData.mobile}</div>
            </div>

            <div className="form-row-step">
              <strong>Email:</strong>
              <div className="value">{formData.email}</div>
            </div>

            <div className="form-row-step">
              <strong>Marital Status:</strong>
              <div className="value">{formData.marital_status}</div>
            </div>

            {formData.marital_status === "married" && (
              <div className="form-row-step">
                <strong>Spouse Name:</strong>
                <div className="value">{formData.spouse_name}</div>
              </div>
            )}

            <div className="form-row-step">
              <strong>Residence Type:</strong>
              <div className="value">{formData.residence_type}</div>
            </div>

            <div className="form-row-step">
              <strong>Present Staying Address:</strong>
              <div className="value">{formData.location}</div>
            </div>

            <div className="form-row-step">
              <strong>State:</strong>
              <div className="value">{formData.state}</div>
            </div>

            <div className="form-row-step">
              <strong>City:</strong>
              <div className="value">{formData.city}</div>
            </div>

            <div className="form-row-step">
              <strong>Pincode:</strong>
              <div className="value">{formData.pincode}</div>
            </div>

            <div className="form-row-step">
              <strong>Is your Present Address as per Aadhaar:</strong>
              <div className="value">{formData.present_address_adhaar}</div>
            </div>

            {formData.present_address_adhaar === "No" && (
              <>
                <div className="form-row-step">
                  <strong>Present Aadhar Address:</strong>
                  <div className="value">{formData.current_location}</div>
                </div>

                <div className="form-row-step">
                  <strong>State:</strong>
                  <div className="value">{formData.current_state}</div>
                </div>

                <div className="form-row-step">
                  <strong>City:</strong>
                  <div className="value">{formData.current_city}</div>
                </div>

                <div className="form-row-step">
                  <strong>Pincode:</strong>
                  <div className="value">{formData.current_pincode}</div>
                </div>

                <div className="form-row-step">
                  <strong>Landmark:</strong>
                  <div className="value">{formData.current_landmark}</div>
                </div>
              </>
            )}

            <div className="form-row-step">
              <strong>Add Co-Applicant:</strong>
              <div className="value">{formData.add_co_applicant}</div>
            </div>

            {formData.add_co_applicant === "Yes" && (
              <>
                <h4>Co-Applicant Details</h4>
                <div className="form-row-step">
                  <strong>Relationship with Applicant:</strong>
                  <div className="value">
                    {formData.co_applicant_relationship}
                  </div>
                </div>

                {formData.co_applicant_relationship === "spouse" && (
                  <div className="form-row-step">
                    <strong>Co-Applicant Spouse Name:</strong>
                    <div className="value">
                      {formData.co_applicant_spouse_name}
                    </div>
                  </div>
                )}

                {formData.co_applicant_relationship === "father" && (
                  <div className="form-row-step">
                    <strong>Co-Applicant Father Name:</strong>
                    <div className="value">
                      {formData.co_applicant_fathers_name}
                    </div>
                  </div>
                )}

                {formData.co_applicant_relationship === "mother" && (
                  <div className="form-row-step">
                    <strong>Co-Applicant Mother Name:</strong>
                    <div className="value">
                      {formData.co_applicant_mothers_name}
                    </div>
                  </div>
                )}

                {formData.co_applicant_relationship === "son" && (
                  <div className="form-row-step">
                    <strong>Co-Applicant son Name:</strong>
                    <div className="value">
                      {formData.co_applicant_son_name}
                    </div>
                  </div>
                )}

                {formData.co_applicant_relationship === "daughter" && (
                  <div className="form-row-step">
                    <strong>Co-Applicant daughter Name:</strong>
                    <div className="value">
                      {formData.co_applicant_daughter_name}
                    </div>
                  </div>
                )}

                <div className="form-row-step">
                  <strong>Co-Applicant Mobile:</strong>
                  <div className="value">{formData.co_applicant_mobile}</div>
                </div>

                <div className="form-row-step">
                  <strong>Co-Applicant Email:</strong>
                  <div className="value">{formData.co_applicant_email}</div>
                </div>
              </>
            )}

            <h4>Income Details</h4>
            <div className="form-row-step">
              <strong>Required Loan Amount:</strong>
              <div className="value">{formData.required_loan_amount}</div>
            </div>

            <div className="form-row-step">
              <strong>Annual Turn Over:</strong>
              <div className="value">{formData.turnover}</div>
            </div>

            <div className="form-row-step">
              <strong>Existing EMI Amount:</strong>
              <div className="value">{formData.existing_emi_amount}</div>
            </div>

            {adminRole !== "customer"&&(
              <div className="form-row-step">
                <strong>Bank Name:</strong>
                <div className="value">{formData.bank_name}</div>
              </div>
            )}

            <div className="form-row-step">
              <strong>Your Company Registered As:</strong>
              <div className="value">{formData.company_type}</div>
            </div>

            <div className="form-row-step">
              <strong>Nature of Business :</strong>
              <div className="value">{formData.business_type}</div>
            </div>

            {formData.business_type === "others" && (
              <div className="form-row-step">
                <strong>Others :</strong>
                <div className="value">{formData.description}</div>
              </div>
            )}

            <div className="form-row-step">
              <strong>Business Place:</strong>
              <div className="value">{formData.business_property}</div>
            </div>

            {formData.business_property === "Own" && (
              <div className="form-row-step">
                <strong>Business Start Year :</strong>
                <div className="value">{formData.business_year}</div>
              </div>
            )}

            <div className="form-row-step">
              <strong>GST Registered:</strong>
              <div className="value">{formData.gst_registered}</div>
            </div>

            {formData.gst_registered === "Yes" && (
              <div className="form-row-step">
                <strong>GST Registered Year :</strong>
                <div className="value">{formData.gst_registerd_year}</div>
              </div>
            )}

            <div className="form-row-step">
              <strong>MSME Registers:</strong>
              <div className="value">{formData.msme_registered}</div>
            </div>

            <div className="form-row-step">
              <strong>Are You Filling ITR:</strong>
              <div className="value">{formData.filling_itr}</div>
            </div>

            {(formData.add_reference === "Relative" || formData.add_reference === "Colleague") && (
              <>
                <h4>Reference Details</h4>
                <div className="form-row-step">
                  <strong>Add Reference:</strong>
                  <div className="value">{formData.add_reference}</div>
                </div>

                <div className="form-row-step">
                  <strong>Name:</strong>
                  <div className="value">{formData.reference_name}</div>
                </div>

                <div className="form-row-step">
                  <strong>Mobile:</strong>
                  <div className="value">{formData.reference_mobile}</div>
                </div>

                <div className="form-row-step">
                  <strong>Address:</strong>
                  <div className="value">{formData.reference_address}</div>
                </div>

                <div className="form-row-step">
                  <strong>Location:</strong>
                  <div className="value">{formData.reference_location}</div>
                </div>
              </>
            )}
          </div>

          <div className="button-sections">
            <Row>
              <Col className="text-end">
                <Button
                  className="custom-back-button"
                  type="button"
                  onClick={onClose}
                >
                  Close
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditBusinessViewModal;